/**
 * Manage request header and response
 * @author Eshan
 */
import { getToken } from "../../modules/login/services/login.service";
import axios from "axios";
import ApiRoutes from "../../constants/api-routes";
import { BehaviorSubject } from "rxjs";

export const pendingApiCalls$ = new BehaviorSubject(0);

// axios.defaults.withCredentials=true;
const ntbInstance = axios.create({
  baseURL: process.env.REACT_APP_NTB_API_GATEWAY,
  withCredentials: true,
});

// Request interceptor for API calls
ntbInstance.interceptors.request.use(
  async (config) => {
    if (config.url === ApiRoutes.SIGN_UP) {
      config.headers = {
        Accept: "application/json",
        c_mf_version: "V1.0",
        c_app_id: "16",
        c_channel_type: "1",
        c_trans_type: "3",
        c_uid: "23423423423",
        c_trans_date: "22-Nov-2021",
        c_private_data: "remark",
      };
    } else if (config.url === ApiRoutes.PIN_ENCRYPTION) {
      config.headers = {
        Accept: "application/json",
        c_mf_version: "V1.0",
        c_app_id: "555222",
        c_channel_type: "1",
        c_trans_type: "3",
        c_uid: "122345677032223",
        c_trans_date: "05-Oct-2020",
        c_private_data: "remark",
      };
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

// Response interceptor for API calls
ntbInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      delete axios.defaults.headers.common["Authorization"];
      await getToken();
      return ntbInstance(originalRequest);
    }
    return Promise.reject(error);
  },
);

/**
 * Loading Spinner Related Request and Response Interceptors
 * */

const loadingSpinnerExcludeUrls = [ApiRoutes.GET_COMMON_DATA, ApiRoutes.GET_COMMON_LIST_DATA];

const isLoadingSpinnerExcludeUrl = (url) => {
  let isLoadingSpinnerExcludeUrl = false;
  loadingSpinnerExcludeUrls.forEach((singleExcludeUrl) => {
    if (url.includes(singleExcludeUrl)) {
      isLoadingSpinnerExcludeUrl = true;
    }
  });
  return isLoadingSpinnerExcludeUrl;
};

ntbInstance.interceptors.request.use((request) => {
  if (request.url && !isLoadingSpinnerExcludeUrl(request.url)) {
    pendingApiCalls$.next(pendingApiCalls$.getValue() + 1);
  }
  return request;
});

ntbInstance.interceptors.response.use(
  (response) => {
    if (response.config.url && !isLoadingSpinnerExcludeUrl(response.config.url)) {
      pendingApiCalls$.next(pendingApiCalls$.getValue() - 1);
    }
    return response;
  },
  (error) => {
    if (error?.config?.url && !isLoadingSpinnerExcludeUrl(error.config.url)) {
      pendingApiCalls$.next(pendingApiCalls$.getValue() - 1);
    }
    return Promise.reject(error);
  },
);
export default ntbInstance;
